<template>
  <div class="dialog" v-if="disable === 'true'">
    <div class="dialog-container">
      <div class="header">
        服务器升级维护通知
      </div>
      <div class="context_con">
        <div class="context_top">亲爱的用户：</div>
        <div class="context_con-groups">
          <div class="context_con-text">
            为优化用户体验,我司服务器将于<span class="times"
              >2021年5月3日22时至5月4日8时</span
            >进行升级维护。
          </div>
          <div class="context_con-text">
            升级维护期间，官网、服务号、小程序、后台等所有相关服务系统将暂停使用。
          </div>
          <div class="context_con-text">在此期间给您带来的不便敬请谅解。</div>
        </div>
      </div>
      <div class="dialog-footer" @click="clickme">我知道了</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DialogStopServer',
  props: {
    disable: {
      type: String,
      default: 'false'
    }
  },
  data() {
    return {};
  },
  methods: {
    clickme() {
      this.$emit('clickStopServer');
    }
  },
  mounted() {},
  created() {}
};
</script>

<style lang="less" scoped>
@import './styles.less';
</style>
